import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import ListItemText from "@material-ui/core/ListItemText";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  disabledLink: {
    color: "red",
    fontSize: "1.5rem",
  },
}));

export default function BanService(props) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const title = props.title;

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Subscripton</DialogTitle>
        <DialogContent>
          <DialogContentText>To Enjoy service make payemnt</DialogContentText>

          <div></div>
        </DialogContent>
        <DialogActions>
          <button onClick={handleClose} className="btn btn-default">
            Cancel
          </button>
          <Link className="btn btn-success" to="/subscription" target="_blank">
            Make Payment
          </Link>
        </DialogActions>
      </Dialog>
      <ListItemText primary={title} onClick={handleClickOpen} />
      <i
        className={classes.disabledLink + " fa fa-lock"}
        onClick={handleClickOpen}
        aria-hidden="true"
      ></i>
    </>
  );
}
